import { useTranslation } from "react-i18next";
import SalaryPerLocationPreview from "../../../Interview/ViewInterview/AvailabilityAndConditions/SalaryPerLocationPreview";

export default function SalaryPerLocationListPreview({interview}) {
  let { t } = useTranslation();

  return (
    <>
      <h1>{t("Salary per Location")}</h1>
        {interview.expectedSalaryPerLocation?.map((salaryPerLocation, index) => (
          <SalaryPerLocationPreview
            key={index}
            model={salaryPerLocation}
            index={index}
          />
        ))}
    </>
  );
}
